import OrderApi from '@apis/order/OrderApi';
import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { useFlow } from '@router/stackflow';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

function useCancelOrder(orderNo: string) {
    const { t } = useTranslation('orderLog');
    const { pop } = useFlow();
    const toast = useToast();
    const queryClient = useQueryClient();
    const { mutate } = useMutation({
        mutationFn: OrderApi.cancelOrder,
        onSuccess() {
            pop();
            toast.info(t('toast.cancelSuccess'));
            queryClient.resetQueries({ queryKey: queries.orders._def });
            queryClient.resetQueries({ queryKey: queries.orderLog._def });
            queryClient.resetQueries({ queryKey: queries.user._def });
            queryClient.resetQueries({ queryKey: queries.stamps._def });
            queryClient.resetQueries({ queryKey: queries.coupons._def });
            queryClient.resetQueries({ queryKey: queries.point._def });
        },
        onError(e: AxiosError<ErrorResponse>) {
            toast.error(e.response?.data.message || t('toast.cancelError'));
        },
    });
    return () => mutate(orderNo);
}

export default useCancelOrder;
